import classNames from "classnames";
import Button from "components/core/Button/Button";
import Markdown from "components/Markdown/Markdown";
import { useUser } from "components/UserContext/UserContext";
import React from "react";
import styles from "./TiiCKERPerksCTA.module.scss";

type Props = {
  loggedOutContent?: string;
  qualifyContent?: string;
  vertical?: boolean;
};

const TiiCKERPerksCTA = (props: Props) => {
  const userContext = useUser();

  // Wait until we have loaded all user context information before we potentially display the CTA
  if (userContext.state.loading) {
    return <></>;
  }

  // if the user is not logged in and they are not eligible we dont want the call to action
  if (
    userContext.state.userId &&
    (!userContext.state.isEligibleForTiiCKERPerk ||
      userContext.state.hasClaimedTiiCKERPerk)
  ) {
    return <></>;
  }

  return (
    <div className="container">
      <div
        className={classNames(styles.container, {
          [styles.vertical]: props.vertical,
        })}
      >
        <div
          className={classNames(styles.textContainer, {
            [styles.fullWidthText]: props.vertical,
          })}
        >
          {props.qualifyContent && userContext.state.userId ? (
            <div className={styles.title}>
              <Markdown markdownText={props.qualifyContent} />
            </div>
          ) : props.loggedOutContent && !userContext.state.userId ? (
            <div className={styles.title}>
              <Markdown markdownText={props.loggedOutContent} />
            </div>
          ) : (
            <h2 className={styles.title}>
              Congratulations! You <span>may qualify</span> for a TiiCKER{" "}
              <span>perk</span>
            </h2>
          )}
          <Button
            arrow
            type="inline"
            className={styles.button}
            href="/tiicker-perks"
          >
            View Details
          </Button>
        </div>
        <img
          src={"/images/tiicker-perk-gift.svg"}
          className={classNames(styles.gift, {
            [styles.verticalGift]: props.vertical,
          })}
        />
      </div>
    </div>
  );
};

export default TiiCKERPerksCTA;
